import React, { useState } from "react";

import ExitIcon from "@mui/icons-material/ExitToAppOutlined";

import useResponsive from "@hooks/useResponsive";
import Settings from "@classes/Settings";
import { MenuDrawerConsumer } from "@contexts/MenuDrawerProvider";
import { StepsDrawerConsumer } from "@contexts/StepsDrawerProvider";
import { createClassName } from "@helpers/utils";

const useHeader = props => {
  const { location, user, partner, advisor, customers } = props;
  const locationPath = location.pathname;
  const isLaptopOrDesktop = useResponsive("up", "md");
  const menuDrawerCtxt = MenuDrawerConsumer();
  const stepsDrawerCtxt = StepsDrawerConsumer();
  const [logoSrc, setLogoSrc] = useState("");
  const classes = createClassName("Header", {});

  if (partner && !logoSrc) {
    import(`@assets/${partner.name}/${partner.logo}.png`).then(logo => {
      setLogoSrc(logo.default);
    });
  }

  const [anchorElNav, setAnchorElNav] = useState(null);
  const [anchorElUser, setAnchorElUser] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);

  const handleLogoClick = () => {
    setAnchorElNav(null);
    setAnchorElUser(null);
    // return navigate("/dashboard");
  };

  const handleOpenNavMenu = () => {    
    const viewNumber = locationPath.split("/").pop() || "1";
    if (Number(viewNumber) > 1 || viewNumber === "sign") {
      return stepsDrawerCtxt.toggleDrawer();
    }

    return menuDrawerCtxt.toggleDrawer();
  };

  const handleOpenUserMenu = event => {
    setMenuOpen(true);
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setMenuOpen(false);
    setAnchorElUser(null);
  };

  const toggleUserMenu = () => {
    setMenuOpen(prevState => !prevState);
  };

  const handleLogout = () => {
    Settings.clear();
    window.location.href = "/";
  };

  const settings = [
    {
      icon: <ExitIcon fontSize="small" />,
      label: <span style={{ verticalAlign: "top" }}>Logga ut</span>,
      handleClick: () => {
        setAnchorElNav(null);
        setAnchorElUser(null);
        handleLogout();
      }
    }
  ];

  return {
    user,
    partner,
    advisor,
    customers,
    isLaptopOrDesktop,
    locationPath,
    classes,
    logoSrc,
    settings,
    anchorElNav,
    anchorElUser,
    menuOpen,
    handleLogoClick,
    handleOpenNavMenu,
    handleOpenUserMenu,
    toggleUserMenu,
    handleCloseUserMenu
  };
};

export default useHeader;
